import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Clients from '@/pages/Clients';
import Zones from '@/pages/Zones';
import Carte from '@/pages/Carte';
import Services from '@/pages/Services';
import Appointments from '@/pages/Appointments';
import Payments from '@/pages/Payments';
import DeclarationsUrssaf from '@/pages/DeclarationsUrssaf';
import DeclarationsAnnual from '@/pages/DeclarationsAnnual';
import Settings from '@/pages/Settings';
import Portfolio from '@/pages/Portfolio';
import MyPortfolio from '@/pages/MyPortfolio';
import DashboardLayout from '@/components/DashboardLayout';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import '@/App.css';

const ProtectedRoute = ({ children }) => {
  const { token } = useAuth();
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/portfolio/:slug" element={<Portfolio />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="clients" element={<Clients />} />
        <Route path="zones" element={<Zones />} />
        <Route path="carte" element={<Carte />} />
        <Route path="services" element={<Services />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="payments" element={<Payments />} />
        <Route path="declarations/urssaf" element={<DeclarationsUrssaf />} />
        <Route path="declarations/annual" element={<DeclarationsAnnual />} />
        <Route path="settings" element={<Settings />} />
        <Route path="my-portfolio" element={<MyPortfolio />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;